module.exports = __webpack_public_path__ + "img/creditcard.380cfd1b.png";